import { combineReducers } from "redux"
import createWebStorage from "redux-persist/lib/storage/createWebStorage"
import { persistReducer } from "redux-persist"
import { userProfileApi } from "appRedux/slices/userApiSlice"
import { wishListApi } from "appRedux/slices/wishListApiSlice"
import { wishItemApi } from "appRedux/slices/wishItemApiSlice"
import { authApi } from "appRedux/slices/authApiSlice"
import { notificationApi } from "appRedux/slices/notificationApiSlice"
import { feedApi } from "appRedux/slices/feedApiSlice"
import { initApi } from "appRedux/slices/initApiSlice"
import { premiumApi } from "appRedux/slices/premiumApiSlice"
import { orderApi } from "appRedux/slices/orderApiSlice"
import { paymentApi } from "appRedux/slices/paymentApiSlice"
import userReducer from "appRedux/slices/userSlice"
import ResetPasswordReducer from "appRedux/slices/resetPasswordSlice"
import globalReducer from "appRedux/slices/globalSlice"
import wishListReducer from "appRedux/slices/wishListSlice"
import wishItemReducer from "appRedux/slices/wishItemSlice"
import itemFormReducer from "appRedux/slices/itemFormSlice"
import listFormReducer from "appRedux/slices/listFormSlice"
import exploreReducer from "appRedux/slices/exploreSlice"
import viewedUserReducer from "appRedux/slices/viewedUserSlice"
import profileTabsReducer from "appRedux/slices/profileTabsSlice"
import notificationsReducer from "appRedux/slices/notificationSlice"
import feedReducer from "appRedux/slices/feedSlice"
import initReducer from "appRedux/slices/initSlice"
import premiumReducer from "appRedux/slices/premiumSlice"
import orderReducer from "appRedux/slices/orderSlice"

export const createNoopStorage = () => ({
  getItem(_key: string) {
    return Promise.resolve(null)
  },
  setItem(_key: string, value: any) {
    return Promise.resolve(value)
  },
  removeItem(_key: string) {
    return Promise.resolve()
  }
})

const localStorageHandler = typeof window !== "undefined" ? createWebStorage("local") : createNoopStorage()
const sessionStorageHandler = typeof window !== "undefined" ? createWebStorage("session") : createNoopStorage()

export const rootPersistConfig = {
  key: "root",
  storage: localStorageHandler,
  keyPrefix: "redux-",
  whitelist: ["user", "explore", "profileTabs", "order", "authApi"]
}

const wishListPersistConfig = {
  key: "wishList",
  storage: sessionStorageHandler,
  keyPrefix: "redux-"
}

const premiumPersistConfig = {
  key: "premium",
  storage: sessionStorageHandler,
  keyPrefix: "redux-"
}

const initPersistConfig = {
  key: "init",
  storage: sessionStorageHandler,
  keyPrefix: "redux-"
}

const rootReducer = combineReducers({
  global: globalReducer,
  resetPassword: ResetPasswordReducer,
  user: userReducer,
  wishList: persistReducer(wishListPersistConfig, wishListReducer),
  wishItem: wishItemReducer,
  itemForm: itemFormReducer,
  listForm: listFormReducer,
  explore: exploreReducer,
  viewedUser: viewedUserReducer,
  profileTabs: profileTabsReducer,
  notification: notificationsReducer,
  feed: feedReducer,
  initSlice: persistReducer(initPersistConfig, initReducer),
  premium: persistReducer(premiumPersistConfig, premiumReducer),
  order: orderReducer,
  [authApi.reducerPath]: authApi.reducer,
  [userProfileApi.reducerPath]: userProfileApi.reducer,
  [wishListApi.reducerPath]: wishListApi.reducer,
  [wishItemApi.reducerPath]: wishItemApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [feedApi.reducerPath]: feedApi.reducer,
  [initApi.reducerPath]: initApi.reducer,
  [premiumApi.reducerPath]: premiumApi.reducer,
  [orderApi.reducerPath]: orderApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer
})

export default persistReducer(rootPersistConfig, rootReducer)
